import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/shellpackage/Package_2.png")